import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  private pathApi = this.config.setting['pathApi'] + "application/";

  constructor(private http: HttpClient, private config: AppConfig) { }
  
  getAllForOptions(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForOptions`);
  } 
  getAll(obj : any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj);
  } 
  save(obj : any): Observable<any> {
    return this.http.post(`${this.pathApi}save`, obj);
  } 
  getByGuid(id : any): Observable<any> {
    return this.http.get(`${this.pathApi}getByGuid/` + id);
  } 
  getByClientId(id : any): Observable<any> {
    return this.http.get(`${this.pathApi}getByClientId/` + id);
  } 
}
